import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { LdLoggerNoiseSoundSignalLoadComponent } from '@app/main/leak-detection/components/ld-helper/ld-logger-noise-sound-signal-load/ld-logger-noise-sound-signal-load.component';
import { ScreenResolutionService } from '@app/core/services/screen-resolution/screen-resolution.service';
import { TranslateDirective } from '@ngx-translate/core';
import { DayjsLocaleService } from '@app/core/i18n/services/dayjs-locale.service';
import { DayJSDateFormat } from '@app/core/enums/date-format.enum';

@Component({
  selector: 'gc-fp-logger-noise-sound-signals-action',
  standalone: true,
  imports: [LdLoggerNoiseSoundSignalLoadComponent, TranslateDirective],
  templateUrl: './fp-logger-noise-sound-signals-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FpLoggerNoiseSoundSignalsActionComponent {
  public readonly scrRes = inject(ScreenResolutionService);
  private readonly dayjsLocale = inject(DayjsLocaleService);

  public soundSignalId = input.required<string | null>();
  public soundSignalUrl = input.required<string | null>();
  public soundSignalStartAt = input.required<string | null | undefined>();

  public readonly soundSignalDate = computed(() => {
    const value = this.soundSignalStartAt();
    if (!value) return null;
    return this.dayjsLocale.dayjs(value).format(DayJSDateFormat.YYYYMMDD);
  });

  public readonly soundSignalTime = computed(() => {
    const value = this.soundSignalStartAt();
    if (!value) return null;
    return this.dayjsLocale.dayjs(value).format(DayJSDateFormat.HHmm);
  });
}
